import { Box, Grid, styled, Typography } from "@mui/material";
import { useRouter } from "next/router";
import React from "react";

import { MemoizedInfoCard } from "../../SDK/Cards/infoCard";
import { sendAnalytics } from "../../utils/analyticsCommon";

const CustomBlogList = styled(Box)(({ theme }) => ({
  width: "100vw",
  display: "flex",
  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  marginTop: "48px",
  paddingTop: "12px",
  ".head-text": {
    padding: "0px 15px",
    fontWeight: 600,
    fontSize: "32px",
    paddingLeft: "6px",
    display: "block",
  },

  ".sub-text": {
    fontSize: "24px",
    color: "#9C9A9D",
    fontWeight: "600",
    padding: "0px 15px",
    paddingLeft: "6px",
    textTransform: "uppercase",
    marginBottom: "4px",
    display: "block",
  },

  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0%",
    paddingRight: "0%",
    marginTop: "24px",
    ".head-text": {
      padding: "0px 15px",
      fontWeight: 600,
      fontSize: "24px",
      paddingLeft: "26px",
    },
    ".sub-text": {
      fontSize: "12px",
      color: "#9C9A9D",
      fontWeight: "600",
      padding: "0px 15px",
      paddingLeft: "26px",
      marginBottom: "0",
      textTransform: "uppercase",
    },
  },
}));

const BrandBlogList = ({ blogData }) => {
  const navigate = useRouter();

  return (
    <CustomBlogList>
      <Box className="main-box">
        <Typography variant="h2" className="head-text">
          {blogData?.headerInfo}
        </Typography>
      </Box>

      <Grid container>
        {blogData?.data?.map((data) => {
          return (
            <Grid
              key={data?.pathRoute}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              item
              xs={12}
              md={4}
              sm={6}
              columnSpacing={2}
              rowSpacing={2}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                const payload = {
                  blogSelected: data?.heading,
                };
                sendAnalytics("blog-card-clicked", payload, "en");
                navigate.push(data?.pathRoute);
              }}
            >
              <Box style={{ margin: "20px" }}>
                <MemoizedInfoCard
                  imageUrl={data?.imageUrl}
                  imageTitle={data?.imageTitle}
                >
                  <Box className="details">
                    <Typography
                      className="title"
                      variant="h2"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "2",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {data.heading}
                    </Typography>
                    <Typography className="date" variant="p">
                      {data?.date}
                    </Typography>

                    <Typography
                      variant="p"
                      className="description"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: "3",
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      {data?.description}
                    </Typography>
                    <Typography className="date" variant="h6">
                      Read More...
                    </Typography>
                  </Box>
                </MemoizedInfoCard>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </CustomBlogList>
  );
};

const MemoizedBrandBlogList = React.memo(BrandBlogList);
export default MemoizedBrandBlogList;
